module.exports = __webpack_public_path__ + "media/icons/notification-close-black@3x-3d52770f.svg";